import { render, staticRenderFns } from "./RulesBy.vue?vue&type=template&id=910dd8cc"
import script from "./RulesBy.vue?vue&type=script&lang=js"
export * from "./RulesBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports